import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { MeshGradient } from "../components/AnimatedBackground";
import {
  ArrowLeft,
  Check,
  Clock,
  Zap,
  Shield,
  HardDrive,
  Key,
} from "lucide-react";

const PRO_FEATURES_LIST = [
  "All Free features",
  "Performance Advisor",
  "Governance Tools",
  "Backup & Restore",
  "Secrets Manager",
  "Priority Support",
  "Cancel anytime",
];

const PRO_FEATURES = [
  {
    icon: <Zap className="w-5 h-5" />,
    name: "Performance Advisor",
    description:
      "Get intelligent suggestions to optimize your queries and database performance",
  },
  {
    icon: <Shield className="w-5 h-5" />,
    name: "Governance Tools",
    description:
      "Manage data access policies and ensure compliance across your databases",
  },
  {
    icon: <HardDrive className="w-5 h-5" />,
    name: "Backup & Restore",
    description:
      "Automated backups with point-in-time recovery for peace of mind",
  },
  {
    icon: <Key className="w-5 h-5" />,
    name: "Secrets Manager",
    description:
      "Securely store and manage database credentials and sensitive data",
  },
];

export function Purchase() {
  return (
    <div className="relative min-h-screen">
      <div className="noise-overlay" />
      <MeshGradient />
      <Navbar currentPage="purchase" />

      <main className="relative z-10 pt-32 pb-20 px-6">
        <div className="max-w-5xl mx-auto">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </a>

          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-zinc-700/50 border border-zinc-600 text-zinc-400 text-sm mb-4">
              <Clock className="w-4 h-4" />
              Coming Early 2026
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">
                Nexatice Pro
              </span>
            </h1>
            <p className="text-zinc-400 max-w-2xl mx-auto">
              Pro features are not yet available for purchase. We're working hard to bring you 
              advanced features in early 2026. Sign up for our newsletter to be notified when 
              Pro launches!
            </p>
          </div>

          <div className="max-w-md mx-auto mb-16">
            <div className="relative bg-zinc-900/60 backdrop-blur-sm rounded-2xl border border-zinc-700 shadow-lg p-8">
              <div className="mb-6">
                <h3 className="text-2xl font-semibold text-white mb-1">
                  Pro Monthly
                </h3>
                <p className="text-zinc-400 text-sm">Unlock all Pro features</p>
              </div>

              <div className="mb-6">
                <div className="flex items-baseline gap-1">
                  <span className="text-5xl font-bold text-zinc-400">€14.99</span>
                  <span className="text-zinc-600">/month</span>
                </div>
                <p className="text-zinc-500 text-sm mt-1">Cancel anytime</p>
                <p className="text-amber-500/70 text-xs mt-2">
                  * Pricing subject to change before launch
                </p>
              </div>

              <ul className="space-y-3 mb-8">
                {PRO_FEATURES_LIST.map((feature, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-2 text-zinc-400 text-sm"
                  >
                    <Check className="w-4 h-4 text-zinc-600 flex-shrink-0" />
                    {feature}
                  </li>
                ))}
              </ul>

              <div
                className="w-full py-3 rounded-lg font-medium flex items-center justify-center gap-2 bg-zinc-700 text-zinc-400 cursor-not-allowed"
              >
                <Clock className="w-4 h-4" />
                Coming Early 2026
              </div>
            </div>
          </div>

          <div className="mb-16">
            <h2 className="text-2xl font-bold text-white text-center mb-8">
              What's included in Pro
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {PRO_FEATURES.map((feature, i) => (
                <div
                  key={i}
                  className="bg-zinc-900/40 backdrop-blur-sm border border-zinc-800 rounded-xl p-5"
                >
                  <div className="w-10 h-10 rounded-lg bg-zinc-700/50 flex items-center justify-center text-zinc-500 mb-3">
                    {feature.icon}
                  </div>
                  <h3 className="text-white font-medium mb-1">
                    {feature.name}
                  </h3>
                  <p className="text-zinc-400 text-sm">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-zinc-900/40 backdrop-blur-sm border border-zinc-800 rounded-2xl p-8 text-center">
            <div className="flex items-center justify-center gap-2 text-zinc-400 mb-4">
              <Clock className="w-5 h-5" />
              <span>Stay Tuned</span>
            </div>
            <p className="text-zinc-500 text-sm max-w-xl mx-auto mb-6">
              We're working on Pro features including yearly subscription options. 
              Sign up for our newsletter on the homepage to be the first to know when 
              Pro becomes available.
            </p>
            <a
              href="/#download"
              className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-600 hover:bg-emerald-500 text-white font-medium rounded-lg transition-colors"
            >
              Get Notified
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
